import { Box, FormControl, Select, Text, TextFieldAppearance, TextFieldSize } from '@bechtel/gds';
import { t } from '@lingui/macro';
import { find, map } from 'lodash';
import React, { FC } from 'react';
import { itrTypeList, milestoneNoneType } from '../form-data';
import { ItrConfig, ItrConfigItemProps, ItrTypeExt } from '../types';
import { useLingui } from '@lingui/react';

export const MilestoneSelectedItem = ({ item }: { item: any }) => {
  const { i18n } = useLingui();
  return (
    <Text family="graphik" size="400" color="grey.1000">
      {i18n._(item.name)}
    </Text>
  );
};
export const MilestoneItem = ({ item }: { item: any }) => {
  const { i18n } = useLingui();
  return (
    <Text size="400" color="grey.1000">
      {i18n._(item.name)}
    </Text>
  );
};

export const ItrConfigItem: FC<ItrConfigItemProps> = ({ projectItrConfig, formikProps }) => {
  const { values, setFieldValue } = formikProps;
  const itrTypeData: ItrTypeExt | undefined = find(itrTypeList, (itrTypeItem) => {
    return itrTypeItem.value === projectItrConfig.itrType;
  });
  //remove weld from the ITR config projectCommodityTypeItrs as its no longer required
  const projectItrConfigs = projectItrConfig.projectCommodityTypeItrs.filter(
    (config) => config?.projectCommodityType?.name !== 'Weld'
  );
  return (
    <Box data-testid={`itr-config-${projectItrConfig.id}`} flexDirection={{ sm: 'column' }} my={{ sm: '500' }}>
      <Box>
        <Text size="400" family="graphik" weight="600" color="grey.1000">
          {projectItrConfig.name}
        </Text>
      </Box>
      <Box mt={{ sm: '400' }} mb={{ sm: '550' }}>
        <Text size="300" family="graphik" color="grey.1000">
          {itrTypeData?.description}
        </Text>
      </Box>
      <Box flexDirection={{ sm: 'column' }}>
        {map(projectItrConfigs, (projectCommodityTypeItrItem) => {
          const selectedItrConfig: ItrConfig | undefined = find(values.itrConfigList, (item) => {
            return item.projectCommodityTypeItrId === projectCommodityTypeItrItem.id;
          });
          const milestoneTypes = [
            milestoneNoneType,
            ...projectCommodityTypeItrItem.projectCommodityType.projectMilestoneTypes,
          ];
          return (
            <Box
              data-testid={`itr-commodity-type-${projectItrConfig.id}-${projectCommodityTypeItrItem.id}`}
              my={{ sm: '450' }}
              key={projectCommodityTypeItrItem.id}
            >
              <FormControl
                label={projectCommodityTypeItrItem.projectCommodityType.name}
                css={`
                  flex-grow: 1;
                `}
              >
                <Select
                  placeholder={t`Milestone`}
                  size={TextFieldSize.LARGE}
                  appearance={TextFieldAppearance.NORMAL}
                  items={milestoneTypes}
                  itemComponent={MilestoneItem}
                  selectedItem={selectedItrConfig?.projectMilestoneType}
                  selectedComponent={MilestoneSelectedItem}
                  onSelectedItemChange={async (changes: any) => {
                    const index = values.itrConfigList.findIndex(
                      (item) => item.projectCommodityTypeItrId == projectCommodityTypeItrItem.id
                    );
                    if (index !== -1)
                      setFieldValue(`itrConfigList[${index}].projectMilestoneType`, changes.selectedItem);
                  }}
                />
              </FormControl>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};
